module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/VGDRINSECT-acaf92008baff193dafc37ce5fe222cf.png";